// import "./App.css";
// import React, { useEffect, useState } from "react";
// import { CometChat } from "@cometchat/chat-sdk-javascript";
// import { CometChatUIKitLoginListener } from "@cometchat/chat-uikit-react";
// import { CometChatHome } from "CometChat/components/CometChatHome/CometChatHome";
// import CometChatLogin from "CometChat/components/CometChatLogin/CometChatLogin";
// import { AppContextProvider } from "CometChat/context/AppContext";
// import { useCometChatContext } from "CometChat/context/CometChatContext";
// import useSystemColorScheme from "CometChat/customHooks";
// import "@cometchat/chat-uikit-react/css-variables.css";
// import useThemeStyles from "CometChat/customHook/useThemeStyles";
// import { usePushNotifications } from "CometChat/usePushNotifications";

// function App() {
//   const [loggedInUser, setLoggedInUser] = useState<CometChat.User | null>(null);

//   /**
//    * State to store the logged-in user
//    * @type {[CometChat.User | null, Function]}
//    */
//   const { styleFeatures, setStyleFeatures } = useCometChatContext();
//   const systemTheme = useSystemColorScheme();
//   const getLoggedInUser = CometChatUIKitLoginListener?.getLoggedInUser();
//   useThemeStyles(styleFeatures, systemTheme, setStyleFeatures,loggedInUser);

//   /**
//    * Effect to handle login and logout listeners
//    */
//   useEffect(() => {
//     CometChat.addLoginListener(
//       "runnable-sample-app",
//       new CometChat.LoginListener({
//         loginSuccess: (user: CometChat.User) => {
//           console.log("login success");
//           setLoggedInUser(user);
//         },
//         logoutSuccess: () => {
//           console.log("logout success");
//           setLoggedInUser(null);
//         },
//       })
//     );

//     return () => CometChat.removeLoginListener("runnable-sample-app");
//   }, []);

//   /**
//    * Effect to set the logged-in user from CometChat UIKit
//    */
//   useEffect(() => {
//     setLoggedInUser(getLoggedInUser);
//   }, [getLoggedInUser]);

//   // ✅ Call hook unconditionally
//   usePushNotifications(loggedInUser);

//   return (
//     <div className="App">
//       <AppContextProvider>
//         {loggedInUser ? <CometChatHome /> : <CometChatLogin />}
//       </AppContextProvider>
//     </div>
//   );
// }

// export default App;

// import "./App.css";
// import React, { useEffect, useState } from "react";
// import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import { CometChat } from "@cometchat/chat-sdk-javascript";
// import { CometChatUIKitLoginListener } from "@cometchat/chat-uikit-react";

// import { AppContextProvider } from "CometChat/context/AppContext";
// import { useCometChatContext } from "CometChat/context/CometChatContext";
// import useSystemColorScheme from "CometChat/customHooks";
// import useThemeStyles from "CometChat/customHook/useThemeStyles";

// import CometChatLogin from "CometChat/components/CometChatLogin/CometChatLogin";
// import { CometChatHome } from "CometChat/components/CometChatHome/CometChatHome";
// import ProtectedRoute from "./routes/ProtectedRoute";

// function App() {
//   const [loggedInUser, setLoggedInUser] = useState<CometChat.User | null>(null);

//   const { styleFeatures, setStyleFeatures } = useCometChatContext();
//   const systemTheme = useSystemColorScheme();
//   const getLoggedInUser = CometChatUIKitLoginListener?.getLoggedInUser();

//   useThemeStyles(styleFeatures, systemTheme, setStyleFeatures, loggedInUser);

//   useEffect(() => {
//     CometChat.addLoginListener(
//       "runnable-sample-app",
//       new CometChat.LoginListener({
//         loginSuccess: (user: CometChat.User) => setLoggedInUser(user),
//         logoutSuccess: () => setLoggedInUser(null),
//       })
//     );

//     return () =>
//       CometChat.removeLoginListener("runnable-sample-app");
//   }, []);

//   useEffect(() => {
//     setLoggedInUser(getLoggedInUser);
//   }, [getLoggedInUser]);

//   return (
//     <div className="App"> {/* ✅ IMPORTANT */}
//       <AppContextProvider>
//         <BrowserRouter>
//           <Routes>
//             {/* Public */}
//             <Route
//               path="/login"
//               element={
//                 loggedInUser ? <Navigate to="/chats" /> : <CometChatLogin />
//               }
//             />

//             {/* Protected */}
//             <Route
//               path="/chats/*"
//               element={
//                 <ProtectedRoute user={loggedInUser}>
//                   <CometChatHome />
//                 </ProtectedRoute>
//               }
//             />

//             {/* Default */}
//             <Route
//               path="*"
//               element={
//                 <Navigate to={loggedInUser ? "/chats" : "/login"} />
//               }
//             />
//           </Routes>
//         </BrowserRouter>
//       </AppContextProvider>
//     </div>
//   );
// }

// export default App;

import "./App.css";
import React, { useEffect, useMemo, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CometChat } from "@cometchat/chat-sdk-javascript";

import { AppContextProvider } from "CometChat/context/AppContext";
import { useCometChatContext } from "CometChat/context/CometChatContext";
import useSystemColorScheme from "CometChat/customHooks";
import useThemeStyles from "CometChat/customHook/useThemeStyles";

import CometChatLogin from "CometChat/components/CometChatLogin/CometChatLogin";
import { CometChatHome } from "CometChat/components/CometChatHome/CometChatHome";
import ProtectedRoute from "./routes/ProtectedRoute";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CometChatSignup from "CometChat/components/CometChatSignup/CometChatSignup";
import { checkMatterStatus } from "CometChat/utils/checkMatterStatus";

function App() {
  const [loggedInUser, setLoggedInUser] = useState<CometChat.User | null | undefined>(undefined);

  const { styleFeatures, setStyleFeatures } = useCometChatContext();
  const systemTheme = useSystemColorScheme();

  useThemeStyles(
    styleFeatures,
    systemTheme,
    setStyleFeatures,
    loggedInUser ?? null
  );

  /* ---------------- INITIAL USER (SAFE) ---------------- */
  useEffect(() => {
    let mounted = true;

    CometChat.getLoggedinUser()
      .then((user) => {
        if (mounted) {
          setLoggedInUser(user);
        }
      })
      .catch(() => {
        setLoggedInUser(null);
      });

    return () => {
      mounted = false;
    };
  }, []);

  /* ---------------- LOGIN LISTENER ---------------- */
  useEffect(() => {
    const listenerId = "runnable-sample-app";

    CometChat.addLoginListener(
      listenerId,
      new CometChat.LoginListener({
        loginSuccess: (user: CometChat.User) => {
          setLoggedInUser(user);
        },
        logoutSuccess: () => {
          setLoggedInUser(null);
        },
      })
    );

    return () => {
      CometChat.removeLoginListener(listenerId);
    };
  }, []);
  
  useEffect(() => {
    // run once when app loads
    checkMatterStatus();

    // run every 1 minute
    const interval = setInterval(() => {
      checkMatterStatus();
    }, 60000);

    return () => clearInterval(interval); // cleanup
  }, []);

  useEffect(() => {
    const loadTheme = async () => {
      const loggedInUser = await CometChat.getLoggedinUser();

      if (!loggedInUser) return;

      const savedTheme = localStorage.getItem(
        `chat_theme_${loggedInUser.getUid()}`
      );

      if (savedTheme) {
        setStyleFeatures(prev => ({
          ...prev,
          theme: savedTheme
        }));
      }
    };

    loadTheme();
  }, [setStyleFeatures]);

  // const { styleFeatures, setStyleFeatures } = useCometChatContext();

  // const systemTheme = useSystemColorScheme();


  const theme = useMemo(() => {
    if (!styleFeatures) return systemTheme;

    if (styleFeatures.theme === "system") {
      return systemTheme;
    }

    return styleFeatures.theme;
  }, [styleFeatures?.theme, systemTheme]);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <div className="App">
      <AppContextProvider>
        <BrowserRouter>
          <Routes>
            {/* PUBLIC */}
            <Route
              path="/login"
              element={
                loggedInUser ? <Navigate to="/chats" /> : <CometChatLogin />
              }
            />
            {/* PROTECTED */}
            <Route
              path="/chats/*"
              element={
                <ProtectedRoute user={loggedInUser}>
                  <CometChatHome />
                </ProtectedRoute>
              }
            />
            {/* DEFAULT */}
            <Route
              path="*"
              element={
                <Navigate to={loggedInUser ? "/chats" : "/login"} />
              }
            />
            {/* <Route
              path="/signup"
              element={<CometChatSignup />}
            /> */}
          </Routes>
        </BrowserRouter>
      </AppContextProvider>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}

export default App;
